import { InjectionToken } from '@angular/core';
import { environment } from '@environment';

/**
 * Whether the «Фотобук» row appears in the product menu at all.
 *
 * Separate from the row's address: an address says whether the host answers, this flag says whether the
 * product is ready to be offered. Фотобук is not — on prod its BFF is off and its OAuth callback is not
 * registered (`gitlab/hydra.yml`), so the owner keeps the surface out of the menu until the product ships. Off on
 * prod, on everywhere else; flipping `photobookMenuEnabled` in the environment of a contour and
 * rebuilding the fronts brings the row back, with no code change.
 *
 * Only the row is hidden. The shell of Фотобук itself is untouched: its own product is always kept by
 * {@link HlmProductSwitcher}, marked instead of linked, so a user already inside keeps a working header.
 */
export const PHOTOBOOK_MENU_ENABLED = new InjectionToken<boolean>('PHOTOBOOK_MENU_ENABLED', {
  providedIn: 'root',
  factory: () => environment.photobookMenuEnabled,
});
